export default class Faq {
    constructor() {
        if (document.getElementById('faqs') !== null) {
            this.readMore();
        }
    }


    readMore() {
        const qas = document.querySelectorAll('.qa');

        qas.forEach(qa => {
            let toggleReadMore = qa.querySelector('.question');

            toggleReadMore.addEventListener('click', e => {
                qa.classList.toggle('open');
            });
        });
    }


    // resizeWindow() {
    //     let resizeTimer;
    //     window.addEventListener('resize', e => {
    //         if (resizeTimer) clearTimeout(resizeTimer);
    //         resizeTimer = setTimeout(() => {
    //             this.readMore();
    //         }, 100, e);
    //     });
    // }

}
